import { Ref, useEffect, useRef } from 'react';
import { useEditPipelineContext } from '../../hooks/useEditPipelineContext';
import {
  ObjectsConfigImperativeRefState,
  ObjectsConfigInnerState
} from '../../../ObjectsConfiguration/components/interfaces/object-config';
import { ObjectsConfig } from '../../../ObjectsConfiguration/components/ObjectsConfig/ObjectsConfig';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';

export function EditPipelineConfigureObjects({
  completeStep,
  updateWizardStepFooterProps
}: WizardStepBaseProps) {
  const { pipeline } = useEditPipelineContext();

  const formRef = useRef<ObjectsConfigImperativeRefState>();

  useEffect(() => {
    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  if (!pipeline) {
    return null;
  }

  const navigateToReviewPage = () => {
    completeStep();
  };

  const onObjectConfigInnerStateUpdate = (state: ObjectsConfigInnerState) => {
    updateWizardStepFooterProps({
      onClick: () => formRef.current?.submitForm(),
      showProgress: state.savingForm,
      disabled: state.disabled,
      children: 'Next'
    });
  };

  return (
    <ObjectsConfig
      isViewMode={false}
      integration={pipeline}
      onSave={navigateToReviewPage}
      onStateUpdate={onObjectConfigInnerStateUpdate}
      formImperativeRef={formRef as unknown as Ref<ObjectsConfigImperativeRefState>}
      canRefreshSchema
    />
  );
}
